import { useQuerySuggestions } from './useQuerySelections';

export { useQuerySuggestions };
